module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-insulation.svg?d993dc88b8eee052680f72f5e91c8fb7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-insulation.svg
// module id = 1031
// module chunks = 1